export const RECURRENCE_TYPES = {
  monthly: 'monthly',
  quarterly: 'quarterly',
  volume: 'volume_monthly',
};
